import React from 'react';
export function ProblemSection() {
  const problems = ['Cada vez que hablás con tus padres… termina igual', 'Sentís que hay cosas del pasado que siguen pesando', 'Te cuesta poner límites sin sentir culpa', 'Intentás cambiar la relación… pero volvés a lo mismo', 'Te frustra sentir que nada cambia'];
  return <section className="text-white py-5 px-5 bg-[#000000]" data-id="element-238">
      <div className="max-w-xl mx-auto" data-id="element-239">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-240">
          😩 ¿Estás viviendo esto...?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-241">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-242">
          {problems.map((problem, idx) => <div key={idx} className="bg-slate-900 border border-slate-800 p-4 rounded-xl flex items-start gap-3" data-id="element-243">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-244">❌</span>
              <p className="text-sm text-slate-300 font-medium leading-relaxed" data-id="element-245">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-246">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-247">
            👉 ¿Cuánto tiempo más vas a seguir cargando con lo mismo?
          </h3>
        </div>
      </div>
    </section>;
}